import React from 'react'

const Flexbox_Coding_Assignment_4 = () => {
  return (
    <div>
      <h1>Coding Assignment 4</h1>
    </div>
  )
}

export default Flexbox_Coding_Assignment_4
